export default __webpack_public_path__ + "static/media/V660_RoHS.f3151a85.pdf";